<template>
	<div class="md-layout md-gutter">
		<div class="md-layout-item md-size-66">
			<form ref="message_form" @submit.prevent="updateMessage">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<font-awesome-icon class="md-icon" :icon="['fa', 'pen']" />
						</div>
						<h4 class="title">Modification du message personnel</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout md-gutter">
							<div class="md-layout-item md-size-100">
								<md-field class="md-invalid">
									<label>Message</label>
									<md-textarea v-model="client.message" name="note" md-autogrow></md-textarea>
									<validation-error :errors="apiValidationErrors.message" />
								</md-field>
							</div>
						</div>
					</md-card-content>
					<md-card-actions md-alignment="left">
						<md-button type="submit" class="md-success">
							Enregistrer
						</md-button>
						<md-button class="md-warning"
								   @click="goBack">
							Retour
						</md-button>
					</md-card-actions>
				</md-card>
			</form>
		</div>
	</div>
</template>

<script>
// Components
import { ValidationError } from "@/components";

// Mixins
import formMixin from "@/mixins/form-mixin";

export default {
	name: "MessageEdit",
	components: { ValidationError },
	mixins: [formMixin],
	data() {
		return {
			client: {}
		}
	},
	methods: {
		async getClientDetails() {
			let { data } = await this.$store.dispatch('clients/getClientDetails', this.$route.params.id)
			this.client = data
		},
		async updateMessage() {
			try {
				await this.$store.dispatch("clients/updateClientNotes", this.client)
				await this.$store.dispatch("alerts/success","Client modifié");
				this.goBack()
			} catch (e) {
				await this.$store.dispatch("alerts/error","Une erreur est survenue");
			}
		},
		goBack() {
			this.$router.go(-1)
		}
	},
	mounted() {
		this.getClientDetails()
	}
}
</script>

<style scoped>

</style>
